import { IDENTITY_ERROR_CODES, type IdentityErrorCode } from '@noconflict/contracts';
import { i18n } from '../i18n';

const known = new Set<string>(IDENTITY_ERROR_CODES);

/**
 * The identity RPCs raise a code as the error message (`last_owner`, `forbidden`, …). The text a person sees
 * comes from `errors:identity.*`; anything unknown gets the generic line, never raw database prose.
 */
export function identityErrorMessage(error: unknown): string {
  const code = error instanceof Error ? error.message : '';
  return known.has(code)
    ? i18n.t(`errors:identity.${code as IdentityErrorCode}`)
    : i18n.t('errors:identity.generic');
}
